module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main